/** @format */

import * as React from "react";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Alert,
  AlertTitle,
  Badge,
  Button,
  Chip,
  Modal,
  Stack,
  Typography,
  useDataGrid,
} from "@pankod/refine-mui";
import { useGetIdentity, useList, useNavigation, useRouterContext } from "@pankod/refine-core";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { createAxios } from "../utils/customAxios";
import { INotification, IStudent, IUser } from "../interfaces";
import moment from "moment";
import { DashboardPageProps } from "@pankod/refine-core/dist/interfaces";
import { PrincipalDashboard } from "components/principal-dashboard";
import { makeRandom } from "../utils/string";
import { SysDashboard } from "components/sys-admin-dashbaord";
import { ParentDashboard } from "components/parent-dashboard";
import { ChevronLeft, ChevronRight, ChevronRightOutlined } from "@mui/icons-material";
// import lessonData from "../const/flData.json"
import lessonData from "../const/flData2.json"
import { cn } from "utils/utils";

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

const columns: GridColDef[] = [
  {
    field: "studentName",
    headerName: "Student name",
    width: 150,
    valueGetter(v) {
      return v.row.firstName + " " + v.row.lastName;
    },
  },
  {
    field: "currentProgress",
    headerName: "Current Progress",
    width: 150,
    valueGetter(v) {
      return "Lesson " + v.row.latestLessonId + " of 28";
    },
  },
  {
    field: "lessonPassed",
    headerName: "Lessons Passed",
    width: 150,
    valueGetter(v) {
      return v.row.lessonsPassed + " Lessons";
    },
  },
  {
    field: "timeInApp",
    headerName: "Time spent",
    width: 150,
    valueGetter(v) {

    
      var minuteSpend = v.row.lastWeekMinutes;
  var hours = Math.floor(minuteSpend / 60);
  var minutes = minuteSpend % 60;
      // return minuteSpend.toString() + " mins";
      return `${hours > 0 ? `${hours}hrs ` : ''}${minutes}mins`;
    },
  },
];

var notificationTypeToAlertSeverity: {
  [i: string]: "error" | "success" | "warning" | "info" | undefined;
} = {
  failed_lesson: "error",
  fluency_report: "success",
  success: "success",
  inactive_students: "warning",
  warning: "warning",
  info: "info",
};

var notificationTypeToAlertTitle: {
  [i: string]: string;
} = {
  failed_lesson: "Failed Lesson",
  fluency_report: "Fluency Report",
  success: "Success",
  inactive_students: "Inactive Students",
  warning: "Warning",
  info: "Info",
};
function TeacherDashboard() {
  const { data: user } = useGetIdentity();
  const [notificationsLoading, setNotificationsLoading] = React.useState(true);
  const [inactive7days, setInactive7days] = React.useState<IStudent[]>([]);
  const [notificationRefreshToken, setNotificationRefreshToken] =
    useState("null");
  const [notificationPages, setNotificationPages] = React.useState<{
    [i: number]: INotification[];
  }>({});

  const notifications = useMemo(() => {
    return Object.values(notificationPages).reduce(
      (acc, val) => acc.concat(val),
      []
    );
  }, [notificationPages]);
  useEffect(() => {
    (async function () {
      const { data } = await createAxios(process.env.REACT_APP_BACKEND).get(
        "/admin/student",
        {
          params: {
            inactiveForXDays: 7,
            _end: 200,
            _start: 0,
          },
        }
      );

      setInactive7days(data);
    })();
  }, []);

  const [currentNotificationPage, setCurrentNotificationPage] =
    React.useState(1);

  useEffect(() => {
    const fetchNotifications = async () => {
      setNotificationsLoading(true);

      try {
        const { data } = await createAxios(process.env.REACT_APP_BACKEND).get(
          "/admin/notification",
          {
            params: {
              _start: (currentNotificationPage - 1) * 10,
              _limit: 10,
              notificationType: "failed_lesson",
            },
          }
        );
        setNotificationPages((prev) => ({
          ...prev,
          [currentNotificationPage]: data,
        }));
        if (currentNotificationPage > 1) {
          setTimeout(() => {
            //scroll scrollableTeacherNotifications to bottom, animated

            const scrollableTeacherNotifications = document.getElementById(
              "scrollableTeacherNotifications"
            );

            scrollableTeacherNotifications?.scrollTo?.({
              top: scrollableTeacherNotifications.scrollHeight,
              behavior: "smooth",
            });
          }, 200);
        }

        setNotificationsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetchNotifications();
  }, [currentNotificationPage, notificationRefreshToken]);

  const { dataGridProps } = useDataGrid<IStudent>({
    initialPageSize: 20,

    resource: "weeklyFluencyReport",
    initialSorter: [
      {
        field: "last_active",
        order: "desc",
      },
    ],
  });

  const [lessonResources, setLessonResources] = useState<boolean>(false);

  const [lessonResourceId, setLessonResourceId] = useState<number>();
  const [audioPlayingIds, setAudioPlayingIds] = useState<string[]>([])

  const navigate = useNavigation();
  const location = useRouterContext().useLocation();


  const updateSearchParams = (params: Record<string, string>) => {
    const searchParams = new URLSearchParams(location.search);
    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value);
    });
    navigate.push(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  useEffect(() => {
    const getSearchParams = () => new URLSearchParams(location.search);
    const param = getSearchParams().get("lessonId")
    if (param) {
      setLessonResourceId(parseInt(param))
    }
  }, [location.search])


  useEffect(() => {
    if (lessonResourceId) {
      updateSearchParams({
        lessonId: lessonResourceId.toString()
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonResourceId])


const lesson1 = lessonData.lesson1.data;
const lesson3 = lessonData.lesson3.data;
const lesson5 = lessonData.lesson5.data;
const lesson6 = lessonData.lesson6.data;
const lesson7 = lessonData.lesson7.data;
const lesson8 = lessonData.lesson8.data;
const lesson10 = lessonData.lesson10.data;
const lesson13 = lessonData.lesson13.data;
const lesson14 = lessonData.lesson14.data;
const lesson15 = lessonData.lesson15.data;
const lesson16 = lessonData.lesson16.data;
const lesson17 = lessonData.lesson17.data;
const lesson18 = lessonData.lesson18.data;
const lesson20 = lessonData.lesson20.data;
const lesson21 = lessonData.lesson21.data;
const lesson22 = lessonData.lesson22.data;
const lesson23 = lessonData.lesson23.data;

const data = [
  {
    lessonId: 1,
    name: " Sounds of the Alphabet",
    data: Object.keys(lesson1)
      .map((k) => ({
        word: lesson1[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/1/answers/${k.toLowerCase()}.mp3`,
      })),
  },
   {
    lessonId: 3,
    name: "Vowel Sounds (Short, Long, and Y)",
    data: Object.keys(lesson3)
      .filter((k) => k.startsWith("L"))
      .map((k) => ({
        key: k,
        imgs: lesson3[k].imgs || [],
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/3/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 5,
    name: "L-Blends",
    data: Object.keys(lesson5)
      .filter((k) => k.startsWith("W"))
      .map((k) => ({
        word: lesson5[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/6/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 6,
    name: "R-Blends",
    data: Object.keys(lesson6)
      .filter((k) => k.startsWith("W"))
      .map((k) => ({
        word: lesson6[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/6/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 7,
    name: "S-Blends",
    data: Object.keys(lesson7)
      .filter((k) => k.startsWith("W"))
      .map((k) => ({
        word: lesson7[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/6/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 8,
    name: "Mixed Blends",
    data: Object.keys(lesson8)
      .filter((k) => k.startsWith("W") && lesson8[k].text)
      .map((k) => ({
        word: lesson8[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/6/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 13,
    name: "Vowel Blends",
    data: Object.keys(lesson13)
      .filter((k) => k.startsWith("W") && lesson13[k].text)
      .map((k) => ({
        word: lesson13[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/8/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 14,
    name: "Vowel Blends",
    data: Object.keys(lesson14)
      .filter((k) => k.startsWith("W") && lesson14[k].text)
      .map((k) => ({
        word: lesson14[k].text,
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/8/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 15,
    name: "Vowel Blends",
    data: Object.keys(lesson15)
      .filter((k) => k.startsWith("W") && lesson15[k].text)
      .map((k) => ({
        word: lesson15[k].text.replace("-", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/8/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 16,
    name: "Vowel/Consonant Blends",
    data: Object.keys(lesson16)
      .filter((k) => k.startsWith("W") && lesson16[k].text)
      .map((k) => ({
        word: lesson16[k].text.replace("-", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/10/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 17,
    name: "Vowel/Consonant Blends",
    data: Object.keys(lesson17)
      .filter((k) => k.startsWith("W") && lesson17[k].text)
      .map((k) => ({
        word: lesson17[k].text.replace("-", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/10/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 18,
    name: "Vowel/Consonant Blends",
    data: Object.keys(lesson18)
      .filter((k) => k.startsWith("W") && lesson18[k].text)
      .map((k) => ({
        word: lesson18[k].text.replace("<mark>", "").replace("</mark>", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/10/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 20,
    name: "Most Common Prefixes (Part 1)",
    data: Object.keys(lesson20)
      .filter((k) => k.startsWith("W") && lesson20[k].text)
      .map((k) => ({
        word: lesson20[k].text.replace("<mark>", "").replace("</mark>", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/13/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 21,
    name: "Most Common Prefixes (Part 2)",
    data: Object.keys(lesson21)
      .filter((k) => k.startsWith("W") && lesson21[k].text)
      .map((k) => ({
        word: lesson21[k].text.replace("<mark>", "").replace("</mark>", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/13/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 22,
    name: "Most Common Suffixes (Part 1)",
    data: Object.keys(lesson22)
      .filter((k) => k.startsWith("W") && lesson22[k].text)
      .map((k) => ({
        word: lesson22[k].text.replace("<mark>", "").replace("</mark>", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/15/answers/${k.toLowerCase()}.mp3`,
      })),
  },
  {
    lessonId: 23,
    name: "Most Common Suffixes (Part 2)",
    data: Object.keys(lesson23)
      .filter((k) => k.startsWith("W") && lesson23[k].text)
      .map((k) => ({
        word: lesson23[k].text.replace("<mark>", "").replace("</mark>", ""),
        audio: `https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/15/answers/${k.toLowerCase()}.mp3`,
      })),
  },
];
  const getBackgroundColor = (index: number) => {
    const colors = [
      'bg-blue-600', // Cobalt blue
      'bg-green-600', // Grass green
      'bg-yellow-500', // Warm gold
    ];
    return colors[index % colors.length];
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid
          container
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ height: "100%" }}
        >
          <Grid xs={12} sm={12} md={12}>
            <Item>
              <Typography variant="h6" sx={{ ml: 1 }}>
                Inactive students
              </Typography>
              <Paper
                style={{
                  height: "30vh",
                  overflowY: "scroll",
                }}
                elevation={0}
              >
                {/** Show list of tags with name and x days ago **/}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    flexWrap: "wrap",
                    marginTop: 15,
                  }}
                >
                  {inactive7days.map((student) => {
                    var inactiveAgo = moment().diff(
                      moment(student.last_active),
                      "days"
                    );
                    return (
                      <Badge
                        style={{ fontSize: 10 }}
                        badgeContent={`${inactiveAgo}d`}
                        color="error"
                      >
                        <a
                          style={{ cursor: "pointer" }}
                          href={`/student/show/${student.id}`}
                        >
                          <Chip
                            style={{
                              textDecoration: "underline",
                              color: "#000",
                            }}
                            variant="outlined"
                            color={"warning"}
                            label={`${student.firstName} ${student.lastName}`}
                          ></Chip>
                        </a>
                      </Badge>
                    );
                  })}
                </div>
              </Paper>
              {/**
               * Show lis
               */}
            </Item>
          </Grid>
          <Grid xs={12} sm={12} md={12}>
            <Item>
              {" "}
              {/* Adjust the height here */}
              <Typography variant="h6" sx={{ ml: 1 }}>
                Failed Lesson Alerts
              </Typography>
              {notifications.length > 0 && (
                <Paper
                  style={{
                    overflowY: "auto", // Changed to 'auto' for better behavior
                    gap: 20,
                    height: "27vh",
                    marginTop: 10,
                  }}
                  elevation={0}
                  id={"scrollableTeacherNotifications"}
                >
                  <div
                    style={{
                      overflowY: "scroll",
                      gap: 20,
                    }}
                  >
                    {notifications.map((notification) => (
                      <Alert
                        severity={
                          notificationTypeToAlertSeverity[
                          notification.notification_type
                          ]
                        }
                        style={{ marginBottom: 5, padding: 1, paddingLeft: 5 }}
                        icon={null}
                        iconMapping={{}}
                        onClick={() => {
                          window.location.href = `/student`;
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            alignSelf: "stretch",
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <AlertTitle
                            style={{
                              fontSize: 11,
                              fontWeight: "bold",
                            }}
                          >
                            {
                              notificationTypeToAlertTitle[
                              notification.notification_type
                              ]
                            }
                          </AlertTitle>
                          <Typography
                            style={{
                              fontSize: 9,
                            }}
                          >
                            {moment(notification.createdAt).fromNow()}
                          </Typography>
                        </div>

                        <Typography
                          style={{
                            fontSize: 10,
                          }}
                        >
                          {notification.content}
                        </Typography>
                      </Alert>
                    ))}
                  </div>
                </Paper>
              )}
              {notificationsLoading && (
                <div
                  style={{
                    flex: 1,
                    minHeight: 50,
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "stretch",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography>Loading...</Typography>
                </div>
              )}
              {!notificationsLoading && (
                <Button
                  disabled={notificationsLoading}
                  onClick={() => {
                    setCurrentNotificationPage((prev) => prev + 1);
                  }}
                  style={{ alignSelf: "stretch", marginTop: 5 }}
                >
                  Load more
                </Button>
              )}
              {!notificationsLoading && (
                <Button
                  disabled={notificationsLoading}
                  onClick={() => {
                    setNotificationPages({});
                    setCurrentNotificationPage((prev) => 1);
                    setNotificationRefreshToken(makeRandom(10));
                  }}
                  style={{ alignSelf: "stretch", marginTop: 5 }}
                >
                  Refresh
                </Button>
              )}
            </Item>
          </Grid>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={6} style={{ height: "100%" }}>
          <Item
            style={{ display: "flex", flexDirection: "column", height: "38vh" }}
          >
            <Typography variant="h6" sx={{ ml: 1 }}>
              Weekly Fluency Report
            </Typography>
            <Paper
              style={{
                height: "100%",
                overflowY: "scroll",
              }}
              elevation={0}
            >
              {/* (1) current progress
(2) # of lessons passed
(3) time in app */}
              <DataGrid
                {...dataGridProps}
                columns={columns}
                density={"compact"}
                initialState={{
                  pagination: {
                    page: 0,
                    pageSize: 5,
                  },
                }}
                onRowClick={(params, event, details) => {
                  window.location.href = `/student/show/${params.row.id}`;
                }}
              />
            </Paper>
          </Item>
          <Item
            style={{
              display: "flex",
              marginTop: "10px",
              flexDirection: "column",
              height: "40vh",
            }}
          >
            <Typography variant="h6" sx={{ ml: 1 }}>
              Resources
            </Typography>
            <Paper
              style={{
                height: "100%",
                overflowY: "scroll",
                marginRight: 20,
              }}
              elevation={0}
            >{/*
              <a
                href="https://www.paperturn-view.com/read-21/teacher-manual-read-21?pid=MzM331043&v=5"
                target="_blank"
                rel="noreferrer"
              >
                <Typography className="text-blue-500 font-bold underline" style={{}}>
                  Teacher's Manual
                </Typography>
              </a>*/}
              <a
                href="https://read21.org/explainer/"
                target="_blank"
                rel="noreferrer"
              >
                <Typography className="text-blue-500 font-bold underline" style={{}}>
                  Explainer Videos
                </Typography>
              </a>
              <div >
                <div className="flex items-center gap-2 cursor-pointer" onClick={() => {
                  setLessonResources(!lessonResources)
                }}>
                  {
                    lessonResources ? (
                      <svg xmlns="http://www.w3.org/2000/svg" className="fill-blue-400  bg-black/10 rounded-sm rotate-90 p-0 border" width="1.4em" height="1.4em" viewBox="0 0 24 24"><path fill="currentColor" d="M12.6 12L8.7 8.1q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.6 4.6q.15.15.213.325t.062.375t-.062.375t-.213.325l-4.6 4.6q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7z"></path></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="fill-blue-400  bg-black/10 rounded-sm p-0 border" width="1.4em" height="1.4em" viewBox="0 0 24 24"><path fill="currentColor" d="M12.6 12L8.7 8.1q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.6 4.6q.15.15.213.325t.062.375t-.062.375t-.213.325l-4.6 4.6q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7z"></path></svg>
                    )
                  }
                  <Typography className=" font-bold" style={{}}>
                    Lesson Sounds
                  </Typography>
                </div>

                {
                  lessonResources &&
                  data.map(l => (
                    <div className="px-7 cursor-pointer">
                      <button onClick={() => {
                        setLessonResourceId(l.lessonId)
                      }}>
                        <Typography className="font-bold text-blue-600">
                          Lesson {l.lessonId}
                        </Typography>
                      </button>
                    </div>
                  ))
                }
              </div>
            </Paper>
          </Item>
        </Grid>
      </Grid>
      <Modal open={lessonResourceId !== undefined} onClose={() => {
        setLessonResourceId(undefined)
      }}>
        <div className="flex justify-center items-center h-full">
          <div className="bg-white w-1/2 p-4 rounded-md flex flex-col gap-2">
            <p className="text-2xl font-bold ">
              Lesson {lessonResourceId}
            </p>
            <p className="border-l-4 border-black/50 px-2">
              Sounds
            </p>
             {data.map((lesson) => {
              const isLesson3 = lesson.lessonId === 3;
              return lesson.lessonId === lessonResourceId && (
                <div key={lesson.lessonId} className={cn(
                  "flex flex-wrap",
                  isLesson3 ? "gap-6 justify-center" : "gap-4"
                )}>
                  {lesson.data.map((item, index) => {
                    const itemHasImages = lesson.lessonId === 3 && (item as any).imgs && (item as any).imgs.length > 0;
                    return (
                      <div key={index} className={
                        cn(
                          itemHasImages 
                            ? "bg-gray-50 hover:bg-gray-100 border border-gray-200" 
                            : getBackgroundColor(index) + " text-white",
                          "rounded-full border border-black/70 cursor-pointer flex flex-col items-center justify-center px-4 mb-2",
                          isLesson3 ? "w-32 h-32" : "w-16 h-16",
                          lessonResourceId === 18 && !isLesson3 && "h-24 w-24"
                        )
                      } onClick={async () => {
                        const audioElement = document.querySelector(`audio[src="${item.audio}"]`) as HTMLAudioElement;
                        if (audioElement) {
                          setAudioPlayingIds([...audioPlayingIds, item.audio])
                          await audioElement.play();
                        }
                      }}>
                        {itemHasImages ? (
                          <div className="flex items-center justify-center gap-2 flex-wrap">
                            {(item as any).imgs.map((img: string, imgIndex: number) => (
                              <img
                                key={imgIndex}
                                src={img}
                                alt={`${(item as any).key || 'image'} ${imgIndex + 1}`}
                                className={cn(
                                  "object-contain",
                                  isLesson3 ? "w-10 h-10" : "w-6 h-6"
                                )}
                              />
                            ))}
                          </div>
                        ) : (
                          <span>{(item as any).word || ''}</span>
                        )}
                        <audio src={item.audio} style={{ display: 'none' }}
                          onEnded={() => {
                            setAudioPlayingIds(prev => prev.filter(id => id !== item.audio));
                          }}
                        />
                        {
                          audioPlayingIds.includes(item.audio) ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256" className={itemHasImages ? "text-gray-600" : "text-white"}><path fill="currentColor" d="M200 36h-40a12 12 0 0 0-12 12v160a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12V48a12 12 0 0 0-12-12m4 172a4 4 0 0 1-4 4h-40a4 4 0 0 1-4-4V48a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4ZM96 36H56a12 12 0 0 0-12 12v160a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12V48a12 12 0 0 0-12-12m4 172a4 4 0 0 1-4 4H56a4 4 0 0 1-4-4V48a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4Z"></path></svg>
                          ) : (<svg xmlns="http://www.w3.org/2000/svg" className={cn(itemHasImages ? "text-gray-600" : "text-white", "cursor-pointer")} width="1.4em" height="1.4em" viewBox="0 0 24 24" >
                            <path fill="currentColor" d="M9 15.714V8.287q0-.368.244-.588q.243-.22.568-.22q.102 0 .213.028q.11.027.211.083l5.843 3.733q.186.13.28.298q.093.167.093.379t-.093.379t-.28.298l-5.843 3.733q-.101.055-.213.083t-.213.028q-.326 0-.568-.22T9 15.714"></path>
                          </svg>)
                        }
                      </div>
                    );
                  })}
                </div>
              );
            })} 
            <Button className="mt-6" onClick={() => {
              setLessonResourceId(undefined)
            }}>
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </Box>
  );
}
const OtherDashboard = ({ }) => {
  const { data: user } = useGetIdentity();
  return (
    <>
      {user.userType === "principal" ? (
        <PrincipalDashboard />
      ) : user.userType === "admin" ? (
        <SysDashboard />
      ) : user.userType === "parent" ? (
        <ParentDashboard />
      ) : (
        <Stack
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          height={"100%"}
        >
          <img height={250} src={"/images/read21.svg"} />
          <Typography variant={"h4"} color={"#0057FF"}>
            Welcome {user?.firstName}!
          </Typography>
        </Stack>
      )}
    </>
  );
};
const DefaultAppPage: FunctionComponent<DashboardPageProps<any>> = ({ }) => {
  const { data: user, isLoading } = useGetIdentity<IUser>();
  return (
    <>
      {!isLoading && (
        <>
          {user?.userType === "teacher" ? (
            <TeacherDashboard />
          ) : (
            <OtherDashboard />
          )}
        </>
      )}
    </>
  );
};

export default DefaultAppPage;
